export const APPLICATION_STATE_ACTION_NAMES = {
  setPageLoading: 'SET_LOADING',
};

export const setLoadingAction = (loadingState) => ({
  type: APPLICATION_STATE_ACTION_NAMES.setPageLoading,
  payload: loadingState,
});
